import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  styled,
  Tooltip,
  Button,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { statusStyleArray } from "../config";
import { formattedAmountWithoutAed } from "../../../utils/CommonFunction";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import authActions from "../../../redux/reducers/auth/actions";
import { useDispatch } from "react-redux";
import { ReactComponent as SmallDhiramIcon } from "../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../utils/CurrencyUtils";
import Permission from "../../../components/Permission";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
}));

export default function ProposalDetails({ details, selectedTab }) {
  const { resetProposalDetails } = authActions;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (item) => {
    dispatch(resetProposalDetails());

    if (selectedTab === 0) {
      navigate("/create-proposal", {
        state: {
          isUpdateDraftProposal: true,
          villa: item,
          isCreateProposal: true,
          isDraft: true,
        },
      });
    } else if (selectedTab === 1) {
      if (item?.form_json == null) {
        navigate("/create-proposal", {
          state: {
            isUpdateDraftProposal: true,
            villa: item,
            isCreateProposal: true,
            isRequested: true,
          },
        });
      } else {
        navigate("/request-proposal", {
          state: { isUpdateDraftProposal: true, villa: item },
        });
      }
    } else {
      // navigate("/request-proposal", {
      //   state: { villa: item, status: "submitted" },
      // });
      navigate(`/proposal/details/${item?.proposal_id}`);
    }
  };

  const handleChange3 = (item) => {
    console.log("ite", item);
    navigate(`/new-create-proposal/${item?.proposal_id}`);
  };

  const handleChange2 = (item) => {
    console.log("called", item);
    if (
      item?.status === "ongoing" ||
      item?.status === "in_warranty" ||
      item?.status === "completed" ||
      item?.status === "completed"
    ) {
      navigate(`/project/details/${item?.proposal_id}`);
    } else {
      navigate(`/proposal/details/${item?.proposal_id}`);
    }
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "77vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Proposal Name</StyledTableCell>
              <StyledTableCell>Project Type</StyledTableCell>
              <StyledTableCell>
                {selectedTab === 1 ? "Proposal Date" : "Start Date"}
              </StyledTableCell>
              <StyledTableCell>
                {selectedTab !== 1 && "End Date"}
              </StyledTableCell>
              {selectedTab !== 1 && (
                <>
                  <StyledTableCell>Customer</StyledTableCell>
                  <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                    <strong
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      Cost ({renderCurrencyIcon('small')})
                    </strong>
                  </StyledTableCell>
                </>
              )}
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.map((item, idx) => (
              <TableRow key={item.id}>
                <StyledTableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    onClick={() => handleChange2(item)}
                    sx={{
                      flexWrap: "wrap",
                      flex: 1,
                      cursor: "pointer",
                      "&:hover .item-text": {
                        color: "blue",
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {selectedTab === 1 ? (
                      <>
                        {item?.project?.project_image?.[0]?.image && (
                          <Box
                            component="img"
                            src={item.project.project_image[0].image}
                            alt="Project Icon"
                            sx={{
                              width: 45,
                              height: 45,
                              borderRadius: "8px",
                              border: "2px solid white",
                              boxShadow: "0px 4px 2.67px 0px #00000026",
                              marginRight: 1,
                            }}
                          />
                        )}
                        <Tooltip title={item?.project.name} arrow>
                          <Box
                            className="item-text"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "150px",
                              cursor: "default",
                            }}
                          >
                            {item?.project.name?.length > 30
                              ? `${item.project.name.slice(0, 30)}...`
                              : item.project.name}
                          </Box>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        {item?.project_image?.[0]?.image && (
                          <Box
                            component="img"
                            src={item.project_image[0].image}
                            alt="Project Icon"
                            sx={{
                              width: 45,
                              height: 45,
                              borderRadius: "8px",
                              border: "2px solid white",
                              boxShadow: "0px 4px 2.67px 0px #00000026",
                              marginRight: 1,
                            }}
                          />
                        )}
                        <Tooltip title={item?.name} arrow>
                          <Box
                            className="item-text"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "150px",
                              cursor: "default",
                            }}
                          >
                            {item?.name?.length > 30
                              ? `${item.name.slice(0, 30)}...`
                              : item.name}
                          </Box>
                        </Tooltip>
                      </>
                    )}
                  </Box>
                </StyledTableCell>

                <StyledTableCell>
                  {selectedTab === 1
                    ? item?.project?.project_type
                    : item?.project_type}
                </StyledTableCell>
                <StyledTableCell>
                  {selectedTab === 1 ? (
                    moment(item?.project?.updatedAt).format("MMM DD, YYYY")
                  ) : (
                    <>
                      {" "}
                      <p
                        style={{
                          color: "#949DAA",
                          marginBottom: "2px",
                          fontWeight: "500",
                        }}
                      >
                        {item?.start_date
                          ? moment(item?.start_date).format("MMM DD, YYYY")
                          : "-"}
                      </p>
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell>
                  {selectedTab !== 1 && (
                    <>
                      <p style={{ color: "#949DAA", fontWeight: "500" }}>
                        {item?.end_date &&
                          moment(item?.end_date).format("MMM DD, YYYY")}
                      </p>
                    </>
                  )}
                </StyledTableCell>
                {selectedTab !== 1 && (
                  <>
                    <StyledTableCell>
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{ textTransform: "capitalize" }}
                      >
                        <Box
                          component="img"
                          src={
                            item?.user_data?.profile_url ||
                            "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                          }
                          alt="Project Icon"
                          sx={{
                            width: 35,
                            height: 35,
                            borderRadius: "50%",
                            border: "2px solid white",
                            boxShadow: "0px 4px 2.67px 0px #00000026",
                            marginRight: 1,
                          }}
                        />
                        {item?.user_data?.username || item?.username}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                      {`${formattedAmountWithoutAed(item?.cost)}`}
                    </StyledTableCell>
                  </>
                )}

                <StyledTableCell>
                  {/* <Typography
                    style={{
                      borderRadius: "34px",
                      padding: "4px 8px",
                      fontSize: "14px",
                      minWidth: "7ch",
                      width: "fit-content",
                      backgroundColor:
                        statusStyleArray.find(
                          (style) =>
                            style.status ===
                            (selectedTab === 1
                              ? item?.project?.status
                              : item?.proposal_status)
                        )?.backgroundColor || "transparent",
                      color:
                        statusStyleArray.find(
                          (style) =>
                            style.status ===
                            (selectedTab === 1
                              ? item?.project?.status
                              : item?.proposal_status)
                        )?.color || "black",
                      border: "none",
                      textAlign: "center",
                    }}
                  >
                    {getStatusDisplayText(
                      selectedTab === 1
                        ? item?.project?.status
                        : item?.proposal_status
                    )}
                  </Typography> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          statusStyleArray.find(
                            (style) =>
                              style.status ===
                              (selectedTab === 1
                                ? item?.project?.status
                                : item?.proposal_status)
                          )?.backgroundColor || "transparent",
                        border: "3px solid #e5e5e5",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "14px",
                        marginLeft: "8px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(
                        selectedTab === 1
                          ? item?.project?.status
                          : item?.proposal_status
                      )}
                    </Typography>
                  </div>
                </StyledTableCell>

                {selectedTab === 0 ? (
                  <StyledTableCell>
                    {item?.status === "proposal" ||
                    item?.status === "ongoing" ||
                    item?.status === "completed" ||
                    item?.status === "in_warranty" ||
                    item?.status === "delivered" ? (
                      // <IconButton
                      //   size="small"
                      //   title="View"
                      //   onClick={() => handleChange2(item)}
                      // >
                      //   <VisibilityIcon fontSize="small" />
                      // </IconButton>
                      <></>
                    ) : (
                      <>
                        {/* {item?.status !== "submitted" &&
                          item?.status !== "draft-by-contractor" && (
                            <IconButton
                              size="small"
                              title="View"
                              onClick={() => handleChange2(item)}
                            >
                              <VisibilityIcon fontSize="20" />
                            </IconButton>
                          )} */}

                        <Permission resource="PROJECTS" action="UPDATE">
                          <Button
                            variant="contained"
                            component="label"
                            onClick={() => handleChange3(item)}
                            sx={{
                              backgroundColor: "#4D6BF6",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: 500,
                              boxShadow: "none",
                              color: "#fff",
                              border: "none",
                              padding: ".3vh .5vw",
                              cursor: "pointer",
                              fontFamily: "Inter Tight",
                              whiteSpace: "nowrap",
                              marginRight: ".5vw",
                              "&:hover": {
                                backgroundColor: "#4D6BF6",
                                border: "none",
                                boxShadow: "none",
                              },
                            }}
                          >
                            Edit
                          </Button>
                        </Permission>
                      </>
                    )}
                  </StyledTableCell>
                ) : (
                  <StyledTableCell>
                    {item?.status === "proposal" ? (
                      // <IconButton
                      //   size="small"
                      //   title="View"
                      //   onClick={() => handleChange2(item)}
                      // >
                      //   <VisibilityIcon fontSize="small" />
                      // </IconButton>
                      <></>
                    ) : (
                      <>
                        {/* {selectedTab !== 1 && selectedTab !== 2 && (
                          <IconButton
                            size="small"
                            title="View"
                            onClick={() => handleChange2(item)}
                          >
                            <VisibilityIcon fontSize="20" />
                          </IconButton>
                        )} */}
                        <Permission resource="PROJECTS" action="UPDATE">
                          <Button
                            variant="contained"
                            component="label"
                            onClick={() => handleChange3(item)}
                            sx={{
                              backgroundColor: "#4D6BF6",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: 500,
                              boxShadow: "none",
                              color: "#fff",
                              border: "none",
                              padding: ".3vh .5vw",
                              cursor: "pointer",
                              fontFamily: "Inter Tight",
                              whiteSpace: "nowrap",
                              marginRight: ".5vw",
                              "&:hover": {
                                backgroundColor: "#4D6BF6",
                                border: "none",
                                boxShadow: "none",
                              },
                            }}
                          >
                            Edit
                          </Button>
                        </Permission>
                      </>
                    )}
                  </StyledTableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
